/**
 * The browser-side re-check of RSVP time windows (spec §3.6, §4.2, K-7). A page can be minutes old (the
 * 5-minute timer) or hours old (the postbuild snapshot), so the hero model is rebuilt from the same data
 * with the current clock: on mount and every minute after. A date whose RSVP has closed, ended or not yet
 * opened loses its RSVP button and its badge reads "Closed" (or "Opens …") without any request.
 * In a static render (postbuild) the clock is the build time and nothing ticks.
 */
import { useEffect, useState } from "react";

export const RECHECK_MS = 60 * 1000;

export function useViewTime(intervalMs = RECHECK_MS) {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    setNow(new Date()); // the static render's clock is the build time; reset it on mount
    const t = setInterval(() => setNow(new Date()), intervalMs);
    return () => clearInterval(t);
  }, [intervalMs]);
  return now;
}
